import React from "react";
import CustomTable from "./CustomTable";
import PaginationModified from "../../data/PaginationModified";

function PaginatedTable({
  columnsValues,
  dataValues,
  paginationData,
  isPage,
  setIsPage,
}) {
  function getPagination() {
    try {
      const pagination = paginationData ? paginationData : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="payoutsTableContainer">
      <CustomTable data={dataValues || []} columns={columnsValues || [{}]} />

      <div className="fullWidthFlexCenter">
        <div className="customTablePaginationContainer">
          <PaginationModified
            isPage={isPage}
            onChangePage={setIsPage}
            pagination={getPagination()}
          />
        </div>
      </div>
    </div>
  );
}

export default PaginatedTable;
